import { useRouter } from "next/router"
import { Card } from "@components/anti/Card"
import { Image } from "@components/anti/Image"
import { extractMeta, imgUrl } from "src/mixins"

export default function CardCinema({ slug, ...props }) {
  const Router = useRouter()
  const imgBgMapper = (type) => {
    const basePath = "/img/bg/"
    switch (type) {
      case "cinema-xxi-deluxe":
      case "cinema-deluxe":
      case "teater-deluxe":
      case "deluxe-teater":
        return `${basePath}img_bg-cinema-xxi-card.png`
      case "the-premiere":
        return `${basePath}img_bg-premiere-card.png`
      case "imax":
        return `${basePath}img_bg-imax-card.png`
      default:
        return "/img/dummy/img_dummy.jpeg"
    }
  }
  const imgMapper = (type) => {
    const basePath = "/img/brand/"
    switch (type) {
      case "cinema-xxi-deluxe":
      case "cinema-deluxe":
      case "teater-deluxe":
      case "deluxe-teater":
        return `${basePath}img_brand-illustration-xxi.png`
      case "the-premiere":
        return `${basePath}img_brand-illustration-premiere.png`
      case "imax":
        return `${basePath}img_brand-illustration-imax.png`
      default:
        return "/img/dummy/img_dummy.jpeg"
    }
  }
  const logo = extractMeta(props.meta, "logo")?.image
  const bg = extractMeta(props.meta, "card_section")?.background_hover
  return (
    <Card
      {...props}
      id={props.className}
      img={imgBgMapper(slug)}
      imgHover={bg ? imgUrl(bg) : null}
      className={`card-cinema ${props.className} ${bg ? "with-img-hover" : ""}`}
      variant="overlay"
      imgRatio="r-1-2"
    >
      <div className="img-wrapper">
        <Image
          src={imgMapper(slug)}
          className={`img-illustration ${slug}`}
          alt="img-illustration"
          fill
        />
      </div>
      <div className="col-title container">
        <div className="img-wrapper">
          <Image
            src={imgUrl(logo)}
            className={`img-title ${slug}`}
            alt="img-title"
            fill
          />
        </div>
      </div>
      <div className="col-text container">
        <p className="text">{props[`description_${Router.locale}`]}</p>
        <div className="rounded-button">
          <i className="air ai-arrow-right" />
        </div>
      </div>
    </Card>
  )
}
